import {
  parseRouteParamToBoolean,
  parseRouteParamToObject,
} from '@kamernet/utilities/URL';

import { defineRoute } from '../defineRoute';

export const DEFAULT_PAYMENT_STATUS_SUCCESS_MESSAGE =
  {} as PaymentStatusMessage;

export const DEFAULT_PAYMENT_INTENT_CLIENT_SECRET = '';

export type PaymentStatusMessage = {
  continueUrl?: string;
} & (
  | { type?: 'general' }
  | {
      type?: 'contactLandlord';
      payload?: {
        landlordName?: string;
      };
    }
);

export type PaymentStatusRouteParams = {
  paymentStatusSuccessMessage?: PaymentStatusMessage | null;
  payment_intent_client_secret?: string | null;
  trackAnalytics?: boolean | null;
  trackAffiliates?: boolean | null;
};

export type PaymentStatusRouteParamsString = {
  paymentStatusSuccessMessage?: string;
  payment_intent_client_secret?: string;
  trackAnalytics?: string;
  trackAffiliates?: string;
};

export const PaymentStatus = defineRoute<
  PaymentStatusRouteParams,
  PaymentStatusRouteParamsString
>({
  pathname: '/paymentstatus',
  nlPathname: '/betalingsstatus',
  routeParamsStringifier: routeParams => {
    return {
      paymentStatusSuccessMessage: routeParams.paymentStatusSuccessMessage
        ? JSON.stringify(routeParams.paymentStatusSuccessMessage)
        : undefined,
      payment_intent_client_secret:
        routeParams.payment_intent_client_secret ?? undefined,
      trackAnalytics: routeParams.trackAnalytics?.toString(),
      trackAffiliates: routeParams.trackAffiliates?.toString(),
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      paymentStatusSuccessMessage:
        parseRouteParamToObject<PaymentStatusMessage>(
          routeParamsString.paymentStatusSuccessMessage,
        ) || DEFAULT_PAYMENT_STATUS_SUCCESS_MESSAGE,
      payment_intent_client_secret:
        routeParamsString.payment_intent_client_secret ||
        DEFAULT_PAYMENT_INTENT_CLIENT_SECRET,
      trackAnalytics: parseRouteParamToBoolean(
        routeParamsString.trackAnalytics,
      ),
      trackAffiliates: parseRouteParamToBoolean(
        routeParamsString.trackAffiliates,
      ),
    };
  },
});
